import { css } from "@emotion/react";
import { kitText, kitBackground } from "@madhive/kit-ui";

const chat = {
  emptyState: css`
    ${kitText.variant.heading1}
    color: var(--color-secondary);
    height: 40vh;
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: var(--spacing-16) 0;
  `,
  error: css`
    padding: var(--chat-padding) var(--chat-padding) 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
  `
};

const input = {
  base: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
    padding-bottom: var(--spacing-24);
    position: absolute;
    bottom: 0;
    z-index: 2;
    ${kitBackground.blurred.secondary}
    .kit-ChatInput {
      padding-bottom: 0;
    }
  `,
  description: css`
    ${kitText.variant.body}
    color: var(--color-tertiary);
    padding: 0 var(--chat-padding);
    text-align: center;
  `
};

const toggle = {
  isClosed: css`
    animation: fadeIn 0.3s ease-in-out forwards;

    @keyframes fadeIn {
      0% {
        display: block;
        opacity: 0;
        filter: blur(10px);
        transform: scale(0.7);
      }
      100% {
        opacity: 1;
        filter: blur(0px);
        transform: scale(1);
      }
    }
  `,
  isOpen: css`
    display: none;
  `
};

export const styles = {
  chat,
  input,
  toggle
};
